module.exports = __webpack_public_path__ + "media/images/icons/twotone/copy-0e7d97216bc7902489c5a917dc6cead4.svg";